import React from 'react';
import { Camera } from 'lucide-react';
import { useStore } from '../store';

export default function SubmitFitPicButton() {
  const isModelAnimationComplete = useStore((state) => state.isModelAnimationComplete);

  const handleSubmitClick = () => {
    const twitterIntentUrl = "https://twitter.com/intent/post?text=%40iratefitpics%20rate%20my%20fit!%0A%0A%5Bpersonalize%20your%20tweet%20here%20and%20don't%20forget%20to%20attach%20your%20fitpic!%5D%0A%0A&url=https%3A%2F%2Firatefitpics.com%2F";
    window.open(twitterIntentUrl, '_blank');
  };

  return (
    <>
      {isModelAnimationComplete && (
        <button
          onClick={handleSubmitClick}
          className="relative group bg-[#9181B7] text-white px-8 py-2.5 rounded-lg 
            hover:bg-[#313337] transition-all duration-300 min-w-[250px]
            flex items-center justify-center gap-2 shadow-lg hover:shadow-xl
            opacity-0 animate-fade-in"
        >
          <Camera className="w-5 h-5" />
          submit a fitpic
        </button>
      )}
    </>
  );
}